import { useGlobalState } from "../../services/context/AuthContext";
import React, { useRef, useState, useEffect } from "react";
import Slider from "react-slick";

interface CalendarItem {
  DepDate: string;
  TotalFare: number;
}

interface CalendarSliderProps {
  calenderMonthWiseData: CalendarItem[][];
  formik: {
    values: { fromDate: string };
    setFieldValue: (field: string, value: any) => void;
    handleSubmit: () => void;
  };
}

const formatDate = (date: string): string => {
  const d = new Date(date);
  return d.toISOString().split("T")[0]; // format as YYYY-MM-DD
};

const SLIDES_VISIBLE = 8;

const CalendarSlider: React.FC<CalendarSliderProps> = ({
  calenderMonthWiseData,
  formik,
}) => {
  const { userInfo } = useGlobalState();
  const sliderRef = useRef<Slider | null>(null);
  const flattenedData = calenderMonthWiseData.flat();
  const [currentSlide, setCurrentSlide] = useState(0);

  const totalSlides = flattenedData.length;

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: SLIDES_VISIBLE,
    slidesToScroll: 1,
    nextArrow: <i className="fa fa-chevron-right nav-icon" />,
    prevArrow: <i className="fa fa-chevron-left nav-icon" />,
    beforeChange: (oldIndex: number, newIndex: number) => {
      const isNext = newIndex > oldIndex;
      const maxStartIndex = totalSlides - SLIDES_VISIBLE;
      if (isNext && newIndex > maxStartIndex) {
        // Prevent overscroll forward
        setTimeout(() => {
          if (sliderRef.current) {
            sliderRef.current.slickGoTo(oldIndex);
          }
        }, 0);
      } else {
        setCurrentSlide(newIndex);
      }
    },
  };

  // ✅ Auto scroll to selected date whenever it changes
  useEffect(() => {
    const index = flattenedData.findIndex(
      (item) => formatDate(item.DepDate) === formik.values.fromDate
    );

    if (index !== -1 && sliderRef.current) {
      const centerIndex = Math.max(0, index - Math.floor(SLIDES_VISIBLE / 2));
      sliderRef.current.slickGoTo(centerIndex);
    }
  }, [formik.values.fromDate, flattenedData]);
  console.log("formik.values.fromDate", formik.values.fromDate);

  return (
    <Slider ref={sliderRef} {...settings}>
      {flattenedData?.map((i, index) => (
        <div
          key={index}
          className={`date-item ${
            formik.values.fromDate === formatDate(i.DepDate) ? "selected" : ""
          }`}
          onClick={() => {
            formik.setFieldValue("fromDate", formatDate(i.DepDate));
            formik.handleSubmit();
          }}
        >
          <span>{formatDate(i.DepDate)}</span>
          <span className="calend-price">
            {userInfo?.currencyCode}
            {i?.TotalFare}
          </span>
        </div>
      ))}
    </Slider>
  );
};

export default CalendarSlider;
